import { render, staticRenderFns } from "./detail-elec-invoice.vue?vue&type=template&id=211eebca&scoped=true&"
import script from "./detail-elec-invoice.vue?vue&type=script&lang=js&"
export * from "./detail-elec-invoice.vue?vue&type=script&lang=js&"
import style0 from "./detail-elec-invoice.vue?vue&type=style&index=0&id=211eebca&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "211eebca",
  null
  
)

export default component.exports